import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useValveAlertTemplates() {
  return useSelector((state: RootState) => state.valve.alertTemplates)
}
